import { useEffect, useState, useRef, useDeferredValue } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchServicesList, removeService } from 'modules/categories/categoriesSlice';
import PharmaciesProductsComponent from 'modules/categories/pharmacies/components/PharmaciesProductsComponent';
import { searchQueryMinLength, status } from 'constants/general';
import { useParams } from 'react-router-dom';

const PharmaciesProductsContainer = () => {
  const dispatch = useDispatch();
  const { priceListId } = useParams();
  const [searchQuery, setSearchQuery] = useState('');
  const InitialQueryString = {
    priceListId,
    pageNumber: 1,
    pageSize: 10,
  };
  const [servicesQueryString, setServicesQueryString] = useState(InitialQueryString);
  const [isCreateProductModalHidden, setIsCreateProductModalHidden] = useState(true);

  const removeServiceStatus = useSelector(state => state.categories.removeService.status);
  const prevRemoveService = useDeferredValue(removeServiceStatus);

  useEffect(() => {
    if (status.SUCCESS === removeServiceStatus && prevRemoveService !== removeServiceStatus) {
      setServicesQueryString({ ...InitialQueryString });
    }
  }, [removeServiceStatus]);

  useEffect(() => {
    dispatch(fetchServicesList(servicesQueryString));
  }, [dispatch, servicesQueryString]);

  const searchBarInputTimeout = useRef(null);

  const handleOnToggleAddProductsModal = isHidden => {
    setIsCreateProductModalHidden(isHidden);
    if (isHidden) setServicesQueryString({ ...InitialQueryString });
  };

  const handleSearchInputChange = (searchTerm, reset) => {
    const queryString = {
      ...servicesQueryString,
      pageNumber: 1,
      isShowMore: false,
    };
    if (searchTerm) queryString.searchterm = searchTerm;
    if (reset) delete queryString.searchterm;

    setServicesQueryString(queryString);
  };

  const handleSearchBarInputChange = event => {
    const { value } = event.target;

    if (value.length > 30) return;
    setSearchQuery(value);

    if (searchBarInputTimeout.current) clearTimeout(searchBarInputTimeout.current);

    if (value && value.length >= searchQueryMinLength) {
      searchBarInputTimeout.current = setTimeout(() => {
        clearTimeout(searchBarInputTimeout.current);
        handleSearchInputChange(value);
      }, 500);
    } else if (value.length < searchQueryMinLength && servicesQueryString.searchterm)
      handleSearchInputChange(value, true);
  };

  const handleShowMoreClick = () => {
    const data = {
      ...servicesQueryString,
    };
    data.pageNumber += 1;
    data.isShowMore = true;
    setServicesQueryString(data);
  };

  const handleRemoveProduct = rowDataPayload => {
    const { id, priceListId: rowPriceListId } = rowDataPayload;
    const payload = {
      id,
      data: {
        priceListId: rowPriceListId,
      },
    };
    dispatch(removeService(payload));
  };

  return (
    <div>
      <PharmaciesProductsComponent
        isCreateProductModalHidden={isCreateProductModalHidden}
        setIsCreateProductModalHidden={handleOnToggleAddProductsModal}
        searchQuery={searchQuery}
        handleSearchBarInputChange={handleSearchBarInputChange}
        servicesQueryString={servicesQueryString}
        handleShowMoreClick={handleShowMoreClick}
        handleRemoveProduct={handleRemoveProduct}
        priceListId={priceListId}
      />
    </div>
  );
};

PharmaciesProductsContainer.propTypes = {};

PharmaciesProductsContainer.defaultProps = {};

export default PharmaciesProductsContainer;
